import styled from "styled-components";
import { Typography } from "../Typography";

//@ts-ignore
export const FormControlHintRoot = styled(Typography).attrs({ variant: "caption" })(() => ({
    marginLeft: "5px",
}));
